exports = module.exports = require("../../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.maskLayer[data-v-45734d4b] {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  top: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.7);\n  z-index: 100;\n}\n.zoomImg[data-v-45734d4b] {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  z-index: 110;\n  background: center center no-repeat;\n  background-size: contain;\n  -webkit-box-shadow: 0px 0px 12px 0px #999;\n          box-shadow: 0px 0px 12px 0px #999;\n  border-radius: 4px;\n}\n.fade-enter-active[data-v-45734d4b],\n.fade-leave-active[data-v-45734d4b] {\n  -webkit-transition: opacity 0.3s;\n  transition: opacity 0.3s;\n}\n.fade-enter[data-v-45734d4b],\n.fade-leave-to[data-v-45734d4b] {\n  opacity: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.28.11@css-loader?{"minimize":false,"sourceMap":false}!./~/_vue-loader@11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-45734d4b","scoped":true,"hasInlineConfig":true}!./~/_less-loader@4.0.5@less-loader/dist/cjs.js?{"sourceMap":false}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./src/components/composite/zoomImg/src/zoomImg.vue
// module id = 717
// module chunks = 1